<template>
  <d2-container>
    <el-button
      class="filter-item"
      type="primary"
      size="mini"
      icon="el-icon-circle-plus"
      @click="getAdd"
      v-permission:function="['keyWordManger:btn_add']"
    >添加</el-button>
    <el-table
      size="small"
      :key="tableKey"
      stripe
      border
      highlight-current-row
      style=" margin-top: 20px"
      :data="secretKeywordList"
    >
      <el-table-column align="center" label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="关键词">
        <template slot-scope="scope">
          <span>{{ scope.row.word }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="背景颜色">
        <template slot-scope="scope">
          <div :style="{backgroundColor:scope.row.color}" class="span"></div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="创建时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="更新时间">
        <template slot-scope="scope">
          <span>{{ scope.row.updateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" fixed="right" width="420">
        <template slot-scope="scope">
          <el-button
            size="small"
            type="primary"
            @click="editCard(scope.row.id)"
            v-permission:function="['keyWordManger:btn_edit']"
            style="margin-top: 10px;"
          >编辑</el-button>
          <el-button
            size="small"
            type="danger"
            @click="delCard(scope.row.id)"
            v-permission:function="['keyWordManger:btn_del']"
            style="margin-top: 10px;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="form" label-width="170px">
        <el-form-item label="名称" prop="word">
          <el-input v-model="form.word" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="背景色" prop="color">
          <el-color-picker v-model="form.color"></el-color-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取 消</el-button>
        <el-button v-if="dialogStatus=='create'" type="primary" @click="create('form')">确 定</el-button>
        <el-button v-else type="primary" @click="update('form')">确 定</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>
<script>
import { mapGetters } from 'vuex'
import {
  getKeywordAdd,
  getKeywordList,
  getKeywordInfo,
  getKeywordEdit,
  getKeywordDel
} from '@/api/demo/secretLanguage/index'
export default {
  name: 'keyWordManger',
  computed: {
    ...mapGetters(['elements'])
  },
  data () {
    return {
      tableKey: 0,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '创建'
      },
      keyWordManger_btn_add: false,
      keyWordManger_btn_edit: false,
      keyWordManger_btn_del: false,
      dialogFormVisible: false,
      secretKeywordList: [],
      form: {
        color: '', // 名称
        word: '' // 关键词
      },
      listLoading: false,
      rules: {
        word: [
          {
            required: true,
            message: '关键词',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 20,
            message: '长度在 1 到 20 个字符',
            trigger: 'blur'
          }
        ],
        color: [
          {
            required: true,
            message: '请选择背景色',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getSearch()
  },
  methods: {
    getSearch () {
      let that = this
      let data = {
        currentPage: 1,
        pageSize: 50
      }
      getKeywordList(data).then(
        res => {
          that.listLoading = true
          that.secretKeywordList = res.records
          that.listLoading = false
        },
        err => {
          console.log('res', err)
        }
      )
    },
    getAdd () {
      let that = this
      that.dialogStatus = 'create'
      that.dialogFormVisible = true
    },
    create (form) {
      let that = this
      const set = that.$refs
      set[form].validate(valid => {
        if (valid) {
          getKeywordAdd(that.form).then(res => {
            that.$message({
              message: '新增成功',
              type: 'success',
              center: true
            })
            that.getSearch()
            that.dialogFormVisible = false
          })
        }
      })
    },
    editCard (id) {
      let that = this
      that.dialogStatus = 'update'
      that.id = id
      getKeywordInfo(id).then(res => {
        that.dialogFormVisible = true
        that.form.word = res.word
        that.form.color = res.color
      })
    },
    update (form) {
      let that = this
      const set = that.$refs
      set[form].validate(valid => {
        if (valid) {
          getKeywordEdit(that.id, that.form).then(res => {
            that.$message({
              message: '编辑成功',
              type: 'success',
              center: true
            })
            that.getSearch()
            that.dialogFormVisible = false
          })
        }
      })
    },
    cancel () {
      let that = this
      that.dialogFormVisible = false
    },
    // 删除
    delCard (id) {
      let that = this
      this.$confirm('此操作将删除该关键词, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          getKeywordDel(id).then(res => {
            that.$message({
              message: '删除成功',
              type: 'success',
              center: true
            })
            that.getSearch()
          })
        })
        .catch(() => {
          that.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style scoped>
.span {
  width: 50px;
  height: 50px;
  display: block;
  margin: 0px auto;
  border: 1px solid rgba(0, 0, 0, 0.3);
}
</style>
